import React from 'react'
import ReactDOM from 'react-dom'
import { authHeader } from '../../_helpers'

class HelpModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      message: '',
      sending: false,
      sent: false,
      error: null
    }
    this.handleClose = this.handleClose.bind(this)
    this.handleBackdrop = this.handleBackdrop.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleClose() {
    this.props.onClose()
  }

  handleBackdrop(e) {
    if (e.target === e.currentTarget) this.handleClose()
  }

  handleSubmit(e) {
    e.preventDefault()
    var message = this.state.message.trim()
    if (!message) return

    this.setState({ sending: true, error: null })

    fetch('/endpoint/reports/support', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeader() },
      body: JSON.stringify({ message: message })
    })
      .then(function (r) { return r.json() })
      .then(function (data) {
        if (data.status === 'success') {
          this.setState({ sent: true, sending: false })
        } else {
          this.setState({ error: data.message || 'Something went wrong.', sending: false })
        }
      }.bind(this))
      .catch(function () {
        this.setState({ error: 'Something went wrong — try again.', sending: false })
      }.bind(this))
  }

  render() {
    var sent = this.state.sent

    return ReactDOM.createPortal(
      <div className="ng-modal-backdrop" onClick={this.handleBackdrop}>
        <div className="ng-modal" role="dialog" aria-modal="true" style={{ maxWidth: 480 }}>
          <div className="ng-modal-header">
            <h5 className="ng-modal-title">
              <span className="fa fa-headset" style={{ marginRight: 8 }}></span>
              Get help
            </h5>
            <button
              type="button"
              className="ng-modal-close"
              aria-label="Close"
              onClick={this.handleClose}
            >
              &times;
            </button>
          </div>

          {sent ? (
            <div className="ng-modal-body" style={{ textAlign: 'center', padding: '32px 24px' }}>
              <span className="fa fa-check-circle" style={{ fontSize: 48, color: '#22c55e', display: 'block', marginBottom: 16 }}></span>
              <p style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>Message sent</p>
              <p style={{ color: '#64748b', margin: '8px 0 0' }}>We'll get back to you shortly.</p>
            </div>
          ) : (
            <form onSubmit={this.handleSubmit}>
              <div className="ng-modal-body">
                <p style={{ margin: '0 0 16px', color: '#475569' }}>
                  Tell us what you need and we'll get back to you as soon as we can.
                </p>
                <textarea
                  className="ng-input"
                  rows="5"
                  placeholder="Write your message here…"
                  value={this.state.message}
                  onChange={function (e) { this.setState({ message: e.target.value }) }.bind(this)}
                  style={{ resize: 'vertical', width: '100%' }}
                  autoFocus
                ></textarea>
                {this.state.error ? (
                  <p style={{ color: '#ef4444', fontSize: 13, margin: '8px 0 0' }}>{this.state.error}</p>
                ) : null}
              </div>
              <div className="ng-modal-footer">
                <button
                  type="submit"
                  className="ng-btn ng-btn-primary ng-btn-sm"
                  disabled={this.state.sending || !this.state.message.trim()}
                >
                  {this.state.sending ? 'Sending…' : 'Send'}
                </button>
                <button
                  type="button"
                  className="ng-btn ng-btn-ghost ng-btn-sm"
                  onClick={this.handleClose}
                >
                  Cancel
                </button>
              </div>
            </form>
          )}
        </div>
      </div>,
      document.body
    )
  }
}

export default HelpModal
